var _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccVacationTabEnabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.37205,
    y: 2.70078,
    width: 7.22087,
    height: 9.27609,
    rx: 1.55522,
    transform: "rotate(-9 1.37205 2.70078)",
    stroke: "#2F3E88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.71561,
    y: 1.56816,
    width: 7.22087,
    height: 9.27609,
    rx: 1.55522,
    transform: "rotate(9 9.71561 1.56816)",
    stroke: "#2F3E88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.61035,
    y: 4.92188,
    width: 7.22087,
    height: 9.27609,
    rx: 1.55522,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.61035,
    y: 4.92188,
    width: 7.22087,
    height: 9.27609,
    rx: 1.55522,
    stroke: "#2F3E88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73259 8.19141C9.45376 8.19141 9.2042 8.32697 9.04861 8.53494C8.89302 8.32697 8.64346 8.19141 8.36463 8.19141C7.8917 8.19141 7.50812 8.57653 7.50812 9.05254C7.50812 9.23586 7.53739 9.40531 7.58822 9.56244C7.83162 10.3327 8.58184 10.7933 8.9531 10.9196C9.00548 10.9381 9.09174 10.9381 9.14412 10.9196C9.51538 10.7933 10.2656 10.3327 10.509 9.56244C10.5598 9.40531 10.5891 9.23586 10.5891 9.05254C10.5891 8.57653 10.2055 8.19141 9.73259 8.19141Z",
    fill: "#ECEEF9",
    stroke: "#2F3E88",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccVacationTabEnabledIcon);
export default __webpack_public_path__ + "static/media/my-acc-vacation-tab-enabled-icon.1c8fcd042532ceb3738869095ff363fa.svg";
export { ForwardRef as ReactComponent };